export default __webpack_public_path__ + "static/O0060-fec2c8923c73940858622fdf33cbf4a1.png";